import React from 'react'

const LoadingTable = () => {
    return (
        <>
           <div className="row px-3 col-12">

       
                    <div className="d-flex justify-content-between">
                        <div className="col-3">
                            <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px', height: 50 }} > </p>

                        </div>

                        <div className='col-3'>
                            <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px', height: 50 }} > </p>

                        </div>
                    </div>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px', height: 50 }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>

                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>

                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px' }} > </p>
                    <div className="d-flex justify-content-between">
                        <div className="col-3">
                            <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px', height: 30 }} > </p>

                        </div>

                        <div className='col-3'>
                            <p className="skeleton" style={{ width: '98%', borderRadius: 5, margin: '0px auto 10px', height: 30 }} > </p>

                        </div>
                    </div>
                    </div>

        </>
    )
}

export default LoadingTable